import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9eeeb022"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "log"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/record"
}, "开奖记录")], -1));
const _hoisted_2 = {
  class: "cont"
};
const _hoisted_3 = {
  class: "guess-tabs"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 2,
  class: "video"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "dmbp_other"
};
import nav_header from '@/components/nav_header.vue';
import swipers from '@/components/swipers.vue';
import years from '@/components/years.vue';
import comment from '@/components/comment.vue';
import priz_result from '@/components/priz_result.vue';
import otherTail from '@/components/otherTail.vue';
import { article_type, article_index, article_like, comment_add, comment_list } from '@/util/http';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import { ref, toRefs } from 'vue';

import { reactive, onBeforeMount } from 'vue';
export default {
  __name: 'guess',
  setup(__props) {
    let dmbpOther = reactive([{
      name: '评论',
      num: '0',
      src: require('@/assets/image/commont.png')
    }, {
      name: '赞',
      num: '0',
      src: require('@/assets/image/zan.png')
    }, {
      name: '分享',
      num: '',
      src: require('@/assets/image/fenxiang.png')
    }, {
      name: ' ',
      num: '0',
      src: require('@/assets/image/look.png')
    }]);
    let yearsss = ref(null);
    let infoFn = datas => {
      if (datas.name == '赞') {
        article_like({
          type: 3
        }, data.uid).then(res => {
          if (res.code == '320') {
            showss.value = true;
            return false;
          }
          if (res.message != "您已赞过") {
            dmbpOther[1].num = dmbpOther[1].num + 1;
          }
          dmbpOther[1].src = require('@/assets/image/on_zan.png');
          showToast(res.message);
        });
      } else if (datas.name == '分享') {
        copy();
      }
    };
    let showss = ref(false);
    let copy = () => {
      let r = window.location.href;
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', r);
      input.setAttribute('readonly', 'readonly');
      input.select();
      input.setSelectionRange(0, 999);
      if (document.execCommand('copy')) {
        showToast("复制成功");
      }
      document.body.removeChild(input);
    };
    let commentList = ref([]);
    const loading = ref(true);
    const finished = ref(false);
    let page = ref(1);
    const onLoad = () => {
      page.value++;
      commentCont(data.uid, page.value);
    };
    let commentCont = (id, page) => {
      //帖子
      comment_list({
        id: id,
        type: 3,
        page: page
      }).then(res => {
        dmbpOther[0].num = res.data.total;
        let datas = res.data.data;
        if (datas.length == 0) {
          finished.value = true;
        } else {
          loading.value = false;
          commentList.value.push(...datas);
        }
      });
    };
    let commentadd = (content, uid, id, url) => {
      //帖子
      comment_add({
        content: content,
        type: 3,
        level_uid: uid,
        level_id: id
      }, url).then(res => {
        if (res.code == '320') {
          showss.value = true;
          activeIndexs.value = false;
          return false;
        }
        showToast(res.message);
        commentCont(data.uid);
        loading.value = false;
      });
    };
    let activeIndexs = ref(false);
    let onSubmitFun = e => {
      //帖子

      commentadd(e.content, e.level_uid, e.level_id, data.uid);
    };
    let returnUp = () => {
      activeIndexs.value = false;
    };
    let opencomment = () => {
      activeIndexs.value = true;
    };
    let commentNext = () => {
      activeIndexs.value = true;
    };
    onBeforeMount(() => {
      article();
    });
    let data = reactive({
      typeId: '',
      listData: '',
      uid: '',
      indexActives: 0
    });
    let {
      indexActives
    } = toRefs(data);
    let article = () => {
      article_type({
        is_ym: 2
      }).then(res => {
        let datas = res.data;
        datas.forEach(item => {
          if (item.name == "幽默猜测") {
            data.typeId = item.id;
          }
        });
        var datesc = new Date();
        let year = datesc.getFullYear();
        articleIndex(data.typeId, 1, '', year);
      });
    };
    let dataConts = ref({});
    let record = ref('');
    let articleIndex = (id, pages, issue = '', year) => {
      article_index({
        type_id: id,
        page: pages,
        periods: issue,
        year
      }).then(res => {
        let datas = res.data;
        dataConts.value = datas;
        data.uid = datas.id;
        dmbpOther[0].num = datas.comment_count;
        dmbpOther[1].num = datas.goodym_count;
        dmbpOther[3].num = datas.browseym.num;
        commentCont(data.uid);
        if (datas.is_like) {
          dmbpOther[1].src = require('@/assets/image/on_zan.png');
        } else {
          dmbpOther[1].src = require('@/assets/image/zan.png');
        }
        ;
        record.value = datas.ym_periods[0];
      });
    };
    let yearFu = data => {
      yearsss.value = data;
      articleIndex(4, 1, '', data);
    };
    let qishuFun = data => {
      console.log(data);
      articleIndex(4, 1, data, yearsss.value);
    };
    let tabsFunc = index => {
      data.indexActives = index;
    };
    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");
      const _component_logos = _resolveComponent("logos");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "幽默猜测"
      }, {
        more: _withCtx(() => [_hoisted_1]),
        _: 1
      }), _createVNode(swipers), _createVNode(years, {
        qishuArray: _unref(dataConts).ym_periods,
        record: _unref(record),
        issue_year: _unref(dataConts).ym_year,
        onYearFuc: _unref(yearFu),
        onQishuFun: _unref(qishuFun)
      }, null, 8, ["qishuArray", "record", "issue_year", "onYearFuc", "onQishuFun"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(_unref(indexActives) == 0 ? 'item active' : 'item'),
        onClick: _cache[0] || (_cache[0] = $event => _unref(tabsFunc)(0))
      }, " 图片猜测 ", 2), _createElementVNode("div", {
        class: _normalizeClass(_unref(indexActives) == 1 ? 'item active' : 'item'),
        onClick: _cache[1] || (_cache[1] = $event => _unref(tabsFunc)(1))
      }, " 视频猜测 ", 2)]), _unref(indexActives) == 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "content",
        innerHTML: _unref(dataConts).content
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true), _unref(indexActives) == 1 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "content",
        style: {
          "margin-top": "0"
        },
        innerHTML: _unref(dataConts).video_content
      }, null, 8, _hoisted_5)) : _createCommentVNode("", true), _unref(indexActives) == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("video", {
        controls: "",
        src: _unref(dataConts).video_url,
        style: {
          "width": "100%"
        }
      }, null, 8, _hoisted_7)])) : _createCommentVNode("", true), _createVNode(priz_result)]), _createElementVNode("div", _hoisted_8, [_createVNode(otherTail, {
        navlist: _unref(dmbpOther),
        onInfoFn: _unref(infoFn)
      }, null, 8, ["navlist", "onInfoFn"])]), _createVNode(_component_van_list, {
        loading: loading.value,
        "onUpdate:loading": _cache[2] || (_cache[2] = $event => loading.value = $event),
        finished: finished.value,
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createVNode(comment, {
          onSubmit: _unref(onSubmitFun),
          onReturnUp: _unref(returnUp),
          onOpencomment: _unref(opencomment),
          onCommentNext: _unref(commentNext),
          commentList: _unref(commentList),
          activeIndexs: _unref(activeIndexs)
        }, null, 8, ["onSubmit", "onReturnUp", "onOpencomment", "onCommentNext", "commentList", "activeIndexs"])]),
        _: 1
      }, 8, ["loading", "finished"]), _createVNode(_component_logos, {
        shows: _unref(showss),
        "onUpdate:shows": _cache[3] || (_cache[3] = $event => _isRef(showss) ? showss.value = $event : showss = $event)
      }, null, 8, ["shows"])], 64);
    };
  }
};